AFRAME.registerComponent("artwork", {
  schema: {
    artworkId: { type: "string" },
    image: { type: "string" },
    frame: { type: "string", default: null },
    artworkInfo: { type: "string" },
    glbModel: { type: "string" },
    scaleX: { type: "number", default: 1 },
    scaleY: { type: "number", default: 1 },
    scaleZ: { type: "number", default: 1 },
    mediumName: { type: "string" },
    completed: { type: "boolean", default: false },
    version: { type: "number", default: 1 },
    remoteArtwork: { type: "string" },
    canBeEdited: { type: "boolean", default: false },
    qrCodeId: { type: "string", default: "" },
    pinned: { type: "boolean", default: false },
    isArtwork: { type: "boolean", default: false },
    resizeOnInit: { type: "boolean", default: false },
    initialScaleX: { type: "number" },
    initialScaleY: { type: "number" },
    initialScaleZ: { type: "number" },
    scaleFactorX: { type: "number" },
    scaleFactorY: { type: "number" },
    scaleFactorZ: { type: "number" },
    myMediaId: { type: "number" },
    isDigitalFile: { type: "boolean" }
  },
  init() {
    this.el.object3D.scale.set(1, 1, 1);
  },
  resizeObject() {
    this.el.object3DMap.mesh.scale.set(1, 1, 1);
    this.el.object3DMap.mesh.updateMatrices();
  },
  tick() {
    if (this.data.image && this.data.isDigitalFile) {
      this.el.object3DMap.mesh.scale.set(1, 1, 1);
    } else if (this.data.image && !this.data.isDigitalFile) {
      this.el.object3DMap.mesh.scale.set(1, 1, 1);
      // this.el.object3DMap.mesh.scale.set(this.data.scaleX, this.data.scaleY, 1);
    }
  },

  update(oldData) {
    // console.log("onUpdate");
    if (this.data.artworkInfo !== oldData.artworkInfo) {
      // console.log("updateArtworkInfo");
      this.resizeObject();
      this.updateArtworkInfo();
      this.resizeObject();
    }
  },
  createBoundingBoxFromObject(obj) {
    return new THREE.Box3().setFromObject(obj);
  },
  udpateQrCode() {
    const qrEl = this.el.querySelector("[artwork-qr]");
    const qrData = {
      artworkInfo: this.data.artworkInfo,
      image: this.data.image,
      remoteArtwork: this.data.remoteArtwork,
      scaleX: this.data.scaleX,
      scaleY: this.data.scaleY,
      scaleZ: this.data.scaleZ,
      initialScaleX: this.data.initialScaleX,
      initialScaleY: this.data.initialScaleY,
      initialScaleZ: this.data.initialScaleZ,
      mediumName: this.data.mediumName,
      glbModel: this.data.glbModel,
      frame: this.data.frame,
      completed: this.data.completed,
      qrCodeId: this.data.qrCodeId,
      resizeOnInit: this.data.resizeOnInit,
      scaleFactorX: this.data.scaleFactorX,
      scaleFactorY: this.data.scaleFactorY,
      scaleFactorZ: this.data.scaleFactorZ,
      myMediaId: this.data.myMediaId,
      isDigitalFile: this.data.isDigitalFile
    };
    if (qrEl) {
      qrEl.setAttribute("artwork-qr", qrData);
      return;
    }

    const qrEntity = document.createElement("a-entity");
    this.el.appendChild(qrEntity);

    qrEntity.setAttribute("artwork-qr", qrData);
  },
  updateArtworkInfo() {
    const infoEl = this.el.querySelector("[artwork-info]");
    const infoData = {
      artworkInfo: this.data.artworkInfo,
      mediumName: this.data.mediumName,
      scaleX: this.data.scaleX,
      scaleY: this.data.scaleY,
      isDefaultMedium: !!this.data.image,
      image: this.data.image
    };
    if (infoEl) {
      infoEl.remove();
    }
    const childEntity = document.createElement("a-entity");
    this.el.appendChild(childEntity);

    childEntity.setAttribute("artwork-info", infoData);
  },
  extractDimensionsCm(str) {
    // Pattern for 'sheet' dimensions
    const sheetPattern = /sheet:\s*([\d.]+)\s*×\s*([\d.]+)\s*cm/;
    // Direct centimeter measurements pattern
    const directCmPattern = /([\d.]+)\s*x\s*([\d.]+)\s*cm/;
    // Pattern to extract centimeter measurements from a mixed string
    const mixedCmPattern = /\(([\d.]+)\s*x\s*([\d.]+)(?:\s*x\s*([\d.]+))?\s*cm\)/;
    let match = str.match(mixedCmPattern);
    if (!match) {
      match = str.match(sheetPattern);
    }
    if (!match) {
      match = str.match(directCmPattern);
    }

    if (match) {
      // Interpreting the first extracted value as height and the second as width
      const heightCm = parseFloat(match[1]);
      const widthCm = parseFloat(match[2]);
      const depthCm = match[3] ? parseFloat(match[3]) : null;
      return { heightCm, widthCm, depthCm };
    } else {
      return null;
    }
  },
  async loadArtwork() {
    // const glbModel = this.data.glbModel;
    // this.el.removeAttribute("gltf-model-plus");
    // this.el.setAttribute("gltf-model-plus", { src: glbModel });
    // this.updateMaterial();
  },
  async onModelLoaded(event) {
    setTimeout(() => {
      this.resizeObject();
      this.updateArtworkInfo();
      // console.log("updateArtworkInfo");
      this.resizeObject();
    }, 300);
  },
  async handlePresentedArtwork() {
    this.el.emit("reset-camera");
  },
  updateFrame() {
    if (!this.data.frame) return;
    const frameEl = this.el.querySelector("[artwork-frame]");
    if (frameEl) {
      frameEl.setAttribute("artwork-frame", {
        model: this.data.frame,
        completed: this.data.completed,
        scaleX: this.data.scaleX,
        scaleY: this.data.scaleY
      });
      return;
    }
    const frameEntity = document.createElement("a-entity");
    this.el.appendChild(frameEntity);

    frameEntity.setAttribute("artwork-frame", {
      model: this.data.frame,
      scaleX: this.data.scaleX,
      scaleY: this.data.scaleY,
      completed: this.data.completed
    });
  }
});
